import { render } from "./ChatChannelPicker.vue?vue&type=template&id=3523f7a6&scoped=true"
import script from "./ChatChannelPicker.vue?vue&type=script&lang=js"
export * from "./ChatChannelPicker.vue?vue&type=script&lang=js"

import "./ChatChannelPicker.vue?vue&type=style&index=0&id=3523f7a6&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3523f7a6"]])

export default __exports__